import { Pipe, PipeTransform } from '@angular/core';
import { toJS } from 'mobx';

@Pipe({ name: 'toJS', pure: true })
export class ToJSPipe implements PipeTransform {
  transform<T>(value: T): T {
    return toJS(value);
  }
}
